import Components from "./config/components";

export default [
  {
    name: "Start",
    path: "/start",
    component: Components.Start,
    meta: {},
  },
  {
    name: "PowerCreditUpgrade",
    path: "/rata-power-credit-upgrade",
    component: Components.PowerCreditUpgrade,
    meta: {
      redirect: true,
    },
  },
  {
    name: "PowerCreditDefaultUpgrade",
    path: "/rata-power-credit-default-upgrade",
    component: Components.PowerCreditDefaultUpgrade,
    meta: {
      redirect: true,
    },
  },
  {
    name: "PowerCredit",
    path: "/rata-power-credit",
    component: Components.PowerCredit,
    meta: {
      redirect: true,
    },
  },
  {
    name: "PromoCredit",
    path: "/rata-promo",
    component: Components.PromoCredit,
    meta: {
      redirect: true,
    },
  },
  {
    name: "PersonalCredit",
    path: "/rata-upgrade",
    component: Components.PersonalCredit,
    meta: {
      redirect: true,
    },
  },
  {
    name: "CreditSwitcher",
    path: "/rata",
    component: Components.CreditSwitcher,
    meta: {
      redirect: true,
    },
  },
  {
    name: "EmailPrivacy",
    path: "/email-privacy",
    component: Components.EmailPrivacy,
    meta: {
      redirect: true,
    },
  },
  {
    name: "Contacts",
    path: "/contatti",
    component: Components.Contacts,
    meta: {
      redirect: true,
    },
  },
  {
    name: "PersonalData",
    path: "/anagrafica",
    component: Components.PersonalData,
    meta: {
      redirect: true,
    },
  },
  {
    name: "CreditRisk",
    path: "/disguidi-finanziari",
    component: Components.CreditRisk,
    meta: {
      redirect: true,
    },
  },
  {
    name: "EmployeeLoan",
    path: "/domanda-cessione",
    component: Components.EmployeeLoan,
    meta: {
      redirect: true,
    },
  },
  {
    name: "IncomeData",
    path: "/reddito",
    component: Components.IncomeData,
    meta: {
      redirect: true,
    },
  },
  {
    name: "FamilyIncome",
    path: "/nucleo-familiare",
    component: Components.FamilyIncome,
    meta: {
      redirect: true,
    },
  },
  {
    name: "EmployerData",
    path: "/lavoro",
    component: Components.EmployerData,
    meta: {
      redirect: true,
    },
  },
  {
    name: "LoanProtection",
    path: "/assicurazione",
    component: Components.LoanProtection,
    meta: {
      redirect: true,
    },
  },
  {
    name: "LoanProtectionConsent",
    path: "/assicurazione-consenso",
    component: Components.LoanProtectionConsent,
    meta: {
      redirect: true,
    },
  },
  {
    name: "LoanProtectionWarning",
    path: "/assicurazione-avviso",
    component: Components.LoanProtectionWarning,
    meta: {
      redirect: true,
    },
  },
  {
    name: "ClubConsent",
    path: "/club-390",
    component: Components.ClubConsent,
    meta: {
      redirect: true,
    },
  },
  {
    name: "ClubWarning",
    path: "/club-avviso",
    component: Components.ClubWarning,
    meta: {
      redirect: true,
    },
  },
  {
    name: "ClubPlus",
    path: "/club-plus",
    component: Components.ClubPlus,
    meta: {
      redirect: true,
    },
  },
  {
    name: "ClubPlusConsent",
    path: "/club-plus-consenso",
    component: Components.ClubPlusConsent,
    meta: {
      redirect: true,
    },
  },
  {
    name: "ClubPlusWarning",
    path: "/club-plus-avviso",
    component: Components.ClubPlusWarning,
    meta: {
      redirect: true,
    },
  },
  {
    name: "ClubLight",
    path: "/club-light",
    component: Components.ClubLight,
    meta: {
      redirect: true,
    },
  },
  {
    name: "DeliveryData",
    path: "/residenza",
    component: Components.DeliveryData,
    meta: {
      redirect: true,
    },
  },
  {
    name: "IdentityDocData",
    path: "/documento",
    component: Components.IdentityDocData,
    meta: {
      redirect: true,
    },
  },
  {
    name: "PaymentData",
    path: "/iban",
    component: Components.PaymentData,
    meta: {
      redirect: true,
    },
  },
  {
    name: "MetlifeProtection",
    path: "/assicurazione-metlife",
    component: Components.MetlifeProtection,
    meta: {
      redirect: true,
    },
  },
  {
    name: "MetlifeProtectionConsent",
    path: "/assicurazione-metlife-consenso",
    component: Components.MetlifeProtectionConsent,
    meta: {
      redirect: true,
    },
  },
  {
    name: "MetlifeProtectionWarning",
    path: "/assicurazione-metlife-avviso",
    component: Components.MetlifeProtectionWarning,
    meta: {
      redirect: true,
    },
  },
  {
    name: "CyberWeby",
    path: "/cyberweby",
    component: Components.CyberWeby,
    meta: {
      redirect: true,
    }
  },
  {
    name: "CyberWebyWarning",
    path: "/cyberweby-avviso",
    component: Components.CyberWebyWarning,
    meta: {
      redirect: true,
    }
  },
  {
    name: "Promo",
    path: "/promo",
    component: Components.Promo,
    meta: {
      redirect: true,
    },
  },
  {
    name: "PromoConfirm",
    path: "/promo-confirm",
    component: Components.PromoConfirm,
    meta: {
      redirect: true,
    },
  },
  {
    name: "Partner",
    path: "/partner",
    component: Components.Partner,
    meta: {
      redirect: true,
    },
  },
  {
    name: "TypMetlifeOK",
    path: "/metlife-ok",
    component: Components.TypMetlifeOK,
    meta: {
      resetState: true,
      redirect: true,
    },
  },
  {
    name: "TypMetlifeKO",
    path: "/metlife-ko",
    component: Components.TypMetlifeKO,
    meta: {
      resetState: true,
      redirect: true,
    },
  },
  {
    name: "TypClubKO",
    path: "/club-ko",
    component: Components.TypClubKO,
    meta: {
      resetState: true,
      redirect: true,
    },
  },
  {
    name: "TypClub",
    path: "/club-ok",
    component: Components.TypClub,
    meta: {
      resetState: true,
      redirect: true,
    },
  },
  {
    name: "TypML",
    path: "/typ-pp-metlife",
    component: Components.TypML,
    meta: {
      resetState: true,
      redirect: true,
    },
  },
  {
    name: "TypML",
    path: "/typ-ml-pp",
    component: Components.TypML,
    meta: {
      resetState: true,
      redirect: true,
    },
  },
  {
    name: "TypML",
    path: "/typ-ml-pc",
    component: Components.TypML,
    meta: {
      resetState: true,
      redirect: true,
    },
  },
  {
    name: "Typ",
    path: "/typ-pp",
    component: Components.Typ,
    meta: {
      resetState: true,
      redirect: true,
    },
  },
  {
    name: "Typ",
    path: "/typ-pc",
    component: Components.Typ,
    meta: {
      resetState: true,
      redirect: true,
    },
  },
  {
    name: "TypClub",
    path: "/typ-club",
    component: Components.TypClub,
    meta: {
      resetState: true,
      redirect: true,
    },
  },
  {
    name: "TypCQ",
    path: "/typ-cq",
    component: Components.TypCQ,
    meta: {
      resetState: true,
      redirect: true,
    },
  },
  {
    name: "TypCQMetlife",
    path: "/typ-cq-metlife",
    component: Components.TypCQMetlife,
    meta: {
      resetState: true,
      redirect: true,
    },
  },
  {
    name: "Typ",
    path: "/typ-pp-club",
    component: Components.Typ,
    meta: {
      resetState: true,
      redirect: true,
    },
  },
  {
    name: "Typ",
    path: "/typ-pp-ade",
    component: Components.Typ,
    meta: {
      resetState: true,
      redirect: true,
    },
  },
  {
    name: "Typ",
    path: "/typ-pp-ade-club",
    component: Components.Typ,
    meta: {
      resetState: true,
      redirect: true,
    },
  },
  {
    name: "Typ",
    path: "/typ-pc-club",
    component: Components.Typ,
    meta: {
      resetState: true,
      redirect: true,
    },
  },
  {
    name: "TypML",
    path: "/typ-pc-metlife",
    component: Components.TypML,
    meta: {
      resetState: true,
      redirect: true,
    },
  },
  {
    name: "Creditworthness",
    path: "/merito-creditizio",
    component: Components.Creditworthness,
    meta: {
      redirect: false,
    },
  },
  {
    name: "Resume",
    path: "/resume",
    component: Components.Resume
  },
  {
    name: "ResumeExpired",
    path: "/resume-ko",
    component: Components.ResumeExpired
  }
];
